import { Controller } from 'stimulus'

// Tap-to-toggle for the "?" tip bubbles on touch devices. Desktop still reveals the
// message via CSS :hover / :focus; this adds a click toggle (stopping the label from
// forwarding the tap to its associated input) and closes on outside tap or Escape.
export default class extends Controller {
  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.toggle('is-open')
  }

  closeOutside(event) {
    if (!this.element.contains(event.target)) {
      this.element.classList.remove('is-open')
    }
  }

  closeOnEsc(event) {
    if (event.key === 'Escape') this.element.classList.remove('is-open')
  }
}
